import React from 'react';
import ReactPlayer from 'react-player';
import './BackgroundVideo.scss';
import { animated } from 'react-spring';
const BackgroundVideo = ({ videoUrl, children  , loop=true , mute=true , styles}) => {
  return (
    <animated.div className='video-container' style={styles}>
      <ReactPlayer
        url={videoUrl}
        playing
        loop
        muted
        width='100vw'
        height='100vh'
        className='video-player'
        config={{
          file: {
            attributes: {
              autoPlay: true,
              muted: mute,
              loop: loop,
              preload: 'auto',
              playsInline: true,
              style: { position: 'absolute', width: '100vw', height: '100vh', objectFit: 'cover' },
            },
          },
        }}
      />
      <div className='video-overlay'>{children}</div>
    </animated.div>
  );
};

export default BackgroundVideo;
